import { FieldViewModel, IOmniaCommand } from "../omnia"
import { commands } from "../strings"
import { IFieldsModuleContext } from "../types"

type Context = Pick<IFieldsModuleContext, "startComponent">

export class InfieldFeaturesCmd implements IOmniaCommand {

    text: string = commands.infieldFeatures;
    icon: string = "fas fa-draw-polygon";

    field: FieldViewModel;

    constructor(private context: Context) {
    }

    canExecute(field: FieldViewModel): boolean {

        return (field && field.field && field.hasBoundary() && (!field.disabled));

    }

    execute(field: FieldViewModel) {

        this.field = field;

        return this.context.startComponent({ component: "omnia-fields-edit-infield-features", execArguments: this });

    }


}
